import {
  LOCATIONMANAGER_REQUEST,
  LOCATIONMANAGER_SUCCESS,
  LOCATIONMANAGER_FAILURE,
  LOCATION_REQUEST,
  LOCATION_SUCCESS,
  LOCATION_FAILURE,
  LOCATION_UPDATE_REQUEST,
  LOCATION_UPDATE_SUCCESS,
  LOCATION_UPDATE_FAILURE,
  SHUTDOWN_HOURS_REQUEST,
  SHUTDOWN_HOURS_SUCCESS,
  SHUTDOWN_HOURS_FAILURE,
  LOCATION_DETAILS_REQUEST,
  LOCATION_DETAILS_SUCCESS,
  LOCATION_DETAILS_FAILURE,
  TEAM_NAMES_REQUEST,
  TEAM_NAMES_SUCCESS,
  TEAM_NAMES_FAILURE,
  ACTIVITY_STATUSES_REQUEST,
  ACTIVITY_STATUSES_SUCCESS,
  ACTIVITY_STATUSES_FAILURE,
  LOCATION_GET_FILES_REQUEST,
  LOCATION_GET_FILES_SUCCESS,
  LOCATION_GET_FILES_FAILURE,
  LOCATION_UPLOAD_FILES_REQUEST,
  LOCATION_UPLOAD_FILES_SUCCESS,
  LOCATION_UPLOAD_FILES_FAILURE,
  LOCATION_GET_FILE_REQUEST,
  LOCATION_GET_FILE_SUCCESS,
  LOCATION_GET_FILE_FAILURE,
  LOCATION_DELETE_FILE_REQUEST,
  LOCATION_DELETE_FILE_SUCCESS,
  LOCATION_DELETE_FILE_FAILURE,
  LOCATION_TYPEAHEAD_REQUEST,
  LOCATION_TYPEAHEAD_SUCCESS,
  LOCATION_TYPEAHEAD_FAILURE,
  CLINIC_GET_FILES_REQUEST,
  CLINIC_GET_FILES_SUCCESS,
  CLINIC_GET_FILES_FAILURE,
  CLINIC_UPLOAD_FILES_REQUEST,
  CLINIC_UPLOAD_FILES_SUCCESS,
  CLINIC_UPLOAD_FILES_FAILURE,
  CLINIC_GET_FILE_REQUEST,
  CLINIC_GET_FILE_SUCCESS,
  CLINIC_GET_FILE_FAILURE,
  CLINIC_DELETE_FILE_REQUEST,
  CLINIC_DELETE_FILE_SUCCESS,
  CLINIC_DELETE_FILE_FAILURE,
  CLINIC_PREVIEW_FILE_REQUEST,
  CLINIC_PREVIEW_FILE_SUCCESS,
  CLINIC_PREVIEW_FILE_FAILURE,
  CLINIC_UPDATE_FILE_REQUEST,
  CLINIC_UPDATE_FILE_SUCCESS,
  CLINIC_UPDATE_FILE_FAILURE,
  LOCATION_COUNT_REQUEST,
  LOCATION_COUNT_SUCCESS,
  LOCATION_COUNT_FAILURE,
  FACILITY_GET_FILES_REQUEST,
  FACILITY_GET_FILES_SUCCESS,
  FACILITY_GET_FILES_FAILURE,
  FACILITY_UPLOAD_FILES_REQUEST,
  FACILITY_UPLOAD_FILES_SUCCESS,
  FACILITY_UPLOAD_FILES_FAILURE,
  FACILITY_UPDATE_FILE_REQUEST,
  FACILITY_UPDATE_FILE_SUCCESS,
  FACILITY_UPDATE_FILE_FAILURE,
  ZIPCODE_REQUEST,
  ZIPCODE_SUCCESS,
  ZIPCODE_FAILURE,
} from './LocationManagerActions';

const initialState = {
  data: [],
  dataCount: [],
  location: {},
  details: {},
  shutdownhours: {},
  zipCode: null,
  typeahead: [],
  isDetailsLoading: false,
  error: null,
  isLoading: false,
  isUpdating: false,
  teamNames: null,
  isTeamNamesLoading: false,
  activityStatuses: null,
  isActivityStatusesLoading: false,
  files: {},
  isFilesLoading: false,
  uploads: {},
  isFilesUploading: false,
  isFileDeleting: false,
  isFileUpdating: false,
  isFileDownloading: false,
  locationfiles: {},
  locationuploads: {},
  isLocationFilesUploading: false,
  facilityfiles: {},
  facilityuploads: {},
  isFacilityFilesLoading: false,
  isFacilityFilesUploading: false,
  isFacilityFilesUpdating: false,
};

export default function locationManagerReducer(
  state = initialState,
  { type, payload, meta },
) {
  switch (type) {
    case LOCATIONMANAGER_REQUEST:
      return { ...state, isLoading: true };
    case LOCATIONMANAGER_SUCCESS:
      return {
        ...state,
        data: payload.data,
        location: {},
        error: null,
        isLoading: false,
      };
    case LOCATIONMANAGER_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case LOCATION_REQUEST:
      return { ...state, isLoading: true };
    case LOCATION_SUCCESS:
      return {
        ...state,
        location: payload.data,
        errors: null,
        isLoading: false,
      };
    case LOCATION_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case LOCATION_UPDATE_REQUEST:
      return { ...state, isUpdating: true };
    case LOCATION_UPDATE_SUCCESS:
      return {
        ...state,
        location: payload.data,
        errors: null,
        isUpdating: false,
      };
    case LOCATION_UPDATE_FAILURE:
      return { ...state, error: payload.error, isUpdating: false };

    case LOCATION_DETAILS_REQUEST:
      return { ...state, isDetailsLoading: true };
    case LOCATION_DETAILS_SUCCESS:
      return {
        ...state,
        details: { ...state.details, [meta.clinicLocationID]: payload.data },
        error: null,
        isDetailsLoading: false,
      };
    case LOCATION_DETAILS_FAILURE:
      return { ...state, error: payload.error, isDetailsLoading: false };

    case TEAM_NAMES_REQUEST:
      return { ...state, isTeamNamesLoading: true };
    case TEAM_NAMES_SUCCESS:
      return {
        ...state,
        teamNames: payload.data,
        error: null,
        isTeamNamesLoading: false,
      };
    case TEAM_NAMES_FAILURE:
      return { ...state, error: payload.error, isTeamNamesLoading: false };

    case ACTIVITY_STATUSES_REQUEST:
      return { ...state, isActivityStatusesLoading: true };
    case ACTIVITY_STATUSES_SUCCESS:
      return {
        ...state,
        activityStatuses: payload.data,
        error: null,
        isActivityStatusesLoading: false,
      };
    case ACTIVITY_STATUSES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isActivityStatusesLoading: false,
      };

    case LOCATION_GET_FILES_REQUEST:
      return { ...state, isFilesLoading: true };
    case LOCATION_GET_FILES_SUCCESS:
      return {
        ...state,
        files: { ...state.actions, [meta.locationCode]: payload.data },
        errors: null,
        isFilesLoading: false,
      };
    case LOCATION_GET_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFilesLoading: false,
      };

    case LOCATION_UPLOAD_FILES_REQUEST:
      return { ...state, uploads: {}, isFilesUploading: true };
    case LOCATION_UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        uploads: payload.data,
        errors: null,
        isFilesUploading: false,
      };
    case LOCATION_UPLOAD_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFilesUploading: false,
      };

    case LOCATION_DELETE_FILE_REQUEST:
      return { ...state, isFileDeleting: true };
    case LOCATION_DELETE_FILE_SUCCESS:
      return {
        ...state,
        isFileDeleting: false,
      };
    case LOCATION_DELETE_FILE_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFileDeleting: false,
      };

    case LOCATION_GET_FILE_REQUEST:
      return { ...state, isFileDownloading: true };
    case LOCATION_GET_FILE_SUCCESS:
      return { ...state, isFileDownloading: false };
    case LOCATION_GET_FILE_FAILURE:
      return { ...state, isFileDownloading: false };

    case LOCATION_TYPEAHEAD_REQUEST:
      return { ...state, isLoading: true };
    case LOCATION_TYPEAHEAD_SUCCESS:
      return {
        ...state,
        typeahead: payload.data,
        errors: null,
        isLoading: false,
      };
    case LOCATION_TYPEAHEAD_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case SHUTDOWN_HOURS_REQUEST:
      return { ...state, isLoading: true };
    case SHUTDOWN_HOURS_SUCCESS:
      return {
        ...state,
        shutdownhours: payload.data,
        errors: null,
        isLoading: false,
      };
    case SHUTDOWN_HOURS_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case CLINIC_GET_FILES_REQUEST:
      return { ...state, isFilesLoading: true };
    case CLINIC_GET_FILES_SUCCESS:
      return {
        ...state,
        locationfiles: { ...state.actions, [meta.locationCode]: payload.data },
        errors: null,
        isFilesLoading: false,
      };
    case CLINIC_GET_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFilesLoading: false,
      };

    case CLINIC_UPLOAD_FILES_REQUEST:
      return { ...state, locationuploads: {}, isLocationFilesUploading: true };
    case CLINIC_UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        locationuploads: payload.data,
        errors: null,
        isLocationFilesUploading: false,
      };
    case CLINIC_UPLOAD_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isLocationFilesUploading: false,
      };

    case CLINIC_GET_FILE_REQUEST:
      return { ...state, isFileDownloading: true };
    case CLINIC_GET_FILE_SUCCESS:
      return { ...state, isFileDownloading: false };
    case CLINIC_GET_FILE_FAILURE:
      return { ...state, isFileDownloading: false };

    case CLINIC_DELETE_FILE_REQUEST:
      return { ...state, isFileDeleting: true };
    case CLINIC_DELETE_FILE_SUCCESS:
      return {
        ...state,
        isFileDeleting: false,
      };
    case CLINIC_DELETE_FILE_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFileDeleting: false,
      };

    case CLINIC_PREVIEW_FILE_REQUEST:
      return { ...state, isFileDownloading: true };
    case CLINIC_PREVIEW_FILE_SUCCESS:
      return { ...state, isFileDownloading: false };
    case CLINIC_PREVIEW_FILE_FAILURE:
      return { ...state, isFileDownloading: false };

    case CLINIC_UPDATE_FILE_REQUEST:
      return { ...state, isFileUpdating: true };
    case CLINIC_UPDATE_FILE_SUCCESS:
      return {
        ...state,
        isFileUpdating: false,
      };
    case CLINIC_UPDATE_FILE_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFileUpdating: false,
      };

    case LOCATION_COUNT_REQUEST:
      return { ...state, isLoading: true };
    case LOCATION_COUNT_SUCCESS:
      return {
        ...state,
        dataCount: payload.data,
        error: null,
        isLoading: false,
      };
    case LOCATION_COUNT_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    case FACILITY_GET_FILES_REQUEST:
      return { ...state, isFacilityFilesLoading: true };
    case FACILITY_GET_FILES_SUCCESS:
      return {
        ...state,
        facilityfiles: { ...state.actions, [meta.locationCode]: payload.data },
        errors: null,
        isFacilityFilesLoading: false,
      };
    case FACILITY_GET_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFacilityFilesLoading: false,
      };

    case FACILITY_UPLOAD_FILES_REQUEST:
      return { ...state, facilityuploads: {}, isFacilityFilesUploading: true };
    case FACILITY_UPLOAD_FILES_SUCCESS:
      return {
        ...state,
        facilityuploads: payload.data,
        errors: null,
        isFacilityFilesUploading: false,
      };
    case FACILITY_UPLOAD_FILES_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFacilityFilesUploading: false,
      };

    case FACILITY_UPDATE_FILE_REQUEST:
      return { ...state, isFacilityFilesUpdating: true };
    case FACILITY_UPDATE_FILE_SUCCESS:
      return {
        ...state,
        isFacilityFilesUpdating: false,
      };
    case FACILITY_UPDATE_FILE_FAILURE:
      return {
        ...state,
        error: payload.error,
        isFacilityFilesUpdating: false,
      };

    case ZIPCODE_REQUEST:
      return { ...state, isLoading: true };
    case ZIPCODE_SUCCESS:
      return {
        ...state,
        zipCode: payload.data,
        errors: null,
        isLoading: false,
      };
    case ZIPCODE_FAILURE:
      return { ...state, error: payload.error, isLoading: false };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/location-manager/LocationManagerReducer.js